import api from '@/api';
import { Message } from 'element-ui'

// 获取cvinfo
export const getCvInfo = async ({ dispatch, state, commit }, type) => {
  let params = {}
  let res = {}

  if(state.mentor){
    res = await api.cvsEditor.getMentorCvInfo(state.cvToken, params);
  }else{
    res = await api.cvsEditor.getCvInfo(state.cvToken, params);
  }

  if (res.code !== 1000) {
    Message.error(res.message);
    return res;
  }
  let cvInfo = res.data || {};
  // 处理创建简历时cvinfo
  let kind = state.CONST_KIND;
  if (kind.indexOf(cvInfo.basic_info.kind) !== -1) {
    let { submodule_info = {}, basic_info = {} } = cvInfo;
    cvInfo = {
      ...cvInfo,
      basic_info: {
        ...basic_info,
        cv_name: '未命名超级简历'
      },
      submodule_info: {
        ...submodule_info,
        edus_ids: [],
        works_ids: [],
        orgs_ids: [],
        language_id: null,
        certificate_id: null,
        other_id: null,
        interest_id: null,
        skill_id: null
      }
    }
  }

  await commit('setCvInfo', cvInfo);
  await dispatch('setList');
  dispatch('cvChecks');
  return res;
}
// 更新cvInfo
export const updatedCvInfo = async ({ dispatch, state, commit }, key) => {
	// update_submodule_info/update_basic_info/update_all_format_info
  let { cvToken, cvInfo } = state;
  let params = {};
  if (key === 'all') {
    params = {
      operation_type: 'update_all_format_info',
      ...cvInfo
    };
  } else {
    params = {
      operation_type: 'update_' + key,
      [key]: cvInfo[key]
    };
  }

  let res = {}
  if(state.mentor){
    res = await api.cvsEditor.updatedMentorCvInfo(cvToken, params);
  }else{
    res = await api.cvsEditor.updatedCvInfo(cvToken, params);
  }
  // 成功再次修改cvinfo
  if (res.code === 1000) {
    cvInfo = {
      ...cvInfo,
      ...(res.data || {})
    };
    // commit('setCvInfo', cvInfo);
    await dispatch('getCvInfo');
    // await dispatch('setList');

  }
  return res;
}


// 重置数据结构
export const setList = async ({ dispatch, state, commit }) => {
  state = JSON.parse(JSON.stringify(state)); // 防止被动修改state
  let {
    cvToken = '',
    cvInfo = {}
  } = state;
  let {
    basic_info = {},
    format_info = {},
    submodule_info = {}
  } = cvInfo;
  let sections_position = submodule_info.sections_position || [];
  let list = []; // 新数据结构
  for (let i = 0; i < sections_position.length; i++) {
    if (!sections_position[i]) continue;
    let name = '';
    let title = '';
    let ids = '';
    let type = sections_position[i].type;
    let constTitle = /works|edus|orgs|extras/gim;
    if (constTitle.test(type)) {
      title = submodule_info[String(type) + '_title'];
    }
    else {
      title = submodule_info.custom_sections_titles[sections_position[i].id + '_title'];
    }
    title = title || '未命名模块';
    // 模块数据
    let obj = {};
    obj.id = sections_position[i].id;
    obj.info_ids = sections_position[i].info_ids;
    obj.title = title;
    obj.type = type;
    obj.key = type === 'custom' ? obj.id : type;
    obj.sections_position = sections_position[i];
    // 子模块数据start
    obj.infos = state[typeof obj.key ==='number' ? obj.id : obj.key] || [];
    if (type === 'extras') {
      obj.others = state.others;
    }
    // 插入整个大模块
    list.push(obj);
  }
  commit('setList', list);
  // 获取模块数据
  if (state.isGetData) dispatch('getModuleData');
  commit('setIsGetData', false);
  return list;
}

// 获取模块数据
export const getModuleData = async ({ dispatch, state, commit }) => {
  let { list, CONST_KIND } = state;
  if (CONST_KIND.indexOf(state.cvInfo.basic_info.kind) !== -1) {
    return false;
  }
  for (let i = 0; i < list.length; i++) {
    if (list[i].type === 'works') dispatch('getWorksList');
    else if (list[i].type === 'edus') dispatch('getEdusList');
    else if (list[i].type === 'orgs') dispatch('getOrgsList');
    else if (list[i].type === 'extras') dispatch('getExtrasList');

    else dispatch('getCustomList', list[i]);
  }
}

// 检查
export const cvChecks = async ({ dispatch, state, commit }) => {
  let res = {};
  let {
    cvInfo,
  } = state;
  let params = {
    ...cvInfo
  };
  res = await api.cvsEditor.cvChecks({cv: params});
  let checkData = res.data || {};
  commit('setCheckData', checkData);
}
// 非会员第二次点击
export const cvCheckLimit = async ({ dispatch, state, commit }) => {
  let params = {};
  let res = await api.cvsEditor.cvChecksLimit(state.cvToken, params);
  console.log(res);
}
